import { HttpClient } from '../HttpClient';

/**
 * Get Borrower
 * @returns {Promise<any>}
 */

export const GetBorrower = async () => {
  try {
    const response = await HttpClient.get('/api/v1/borrower/details');
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
};
